/**
 * onCourse Checkout API
 * An API for interacting with the Checkout System
 *
 * OpenAPI spec version: v1
 * Contact: support@ish.com.au
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

export const createStringEnum = <T extends string>(o: Array<T>): {[K in T]: K} => {
  return o.reduce((res, key) => {
    res[key] = key;
    return res;
  }, Object.create(null));
};

/**
* 
* @export
* @class Amount
*/
export class Amount {
  /**
  * total price excluding discounts
  * @type {number}
  * @memberof Amount
  */
  total?: number;
  /**
  * total discount amount
  * @type {number}
  * @memberof Amount
  */
  discount?: number;
  /**
  * total price including discounts (discounted price)
  * @type {number}
  * @memberof Amount
  */
  subTotal?: number;
  /**
  * min amount that user need to pay for invoice/invoices (can be less than subTotal if payment plan invoices precented)
  * @type {number}
  * @memberof Amount
  */
  minPayNow?: number;
  /**
  * actual amount allocated for invoice/invoices (equalse subTotal if payment plan invoices not presented)
  * @type {number}
  * @memberof Amount
  */
  payNow?: number;
  /**
  * true if minPayNow less that subTotal
  * @type {boolean}
  * @memberof Amount
  */
  isEditable?: boolean;
  /**
  * voucher payments list - appears if redeem any kind of vouchers
  * @type {Array<VoucherPayment>}
  * @memberof Amount
  */
  voucherPayments?: Array<VoucherPayment>;
  /**
  * credit amount that will be used to pay for current invoice/invoices (students credit notes)
  * @type {number}
  * @memberof Amount
  */
  credit?: number;
  /**
  * amount paid by card
  * @type {number}
  * @memberof Amount
  */
  ccPayment?: number;
  /**
  * outstanding owing amount
  * @type {number}
  * @memberof Amount
  */
  owing?: number;
  /**
  * total sum of tax rates for all courses added to the cart
  * @type {number}
  * @memberof Amount
  */
  totalTax?: number;
}/**
* 
* @export
* @class Application
*/
export class Application {
  /**
  * 
  * @type {string}
  * @memberof Application
  */
  contactId: string;
  /**
  * 
  * @type {string}
  * @memberof Application
  */
  classId: string;
  /**
  * 
  * @type {Array<string>}
  * @memberof Application
  */
  warnings: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof Application
  */
  errors: Array<string>;
  /**
  * 
  * @type {boolean}
  * @memberof Application
  */
  selected: boolean;
  /**
  * 
  * @type {Array<FieldHeading>}
  * @memberof Application
  */
  fieldHeadings: Array<FieldHeading>;
}/**
* 
* @export
* @class Article
*/
export class Article {
  /**
  * 
  * @type {string}
  * @memberof Article
  */
  contactId: string;
  /**
  * 
  * @type {string}
  * @memberof Article
  */
  productId: string;
  /**
  * 
  * @type {Array<string>}
  * @memberof Article
  */
  warnings: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof Article
  */
  errors: Array<string>;
  /**
  * 
  * @type {number}
  * @memberof Article
  */
  price: number;
  /**
  * 
  * @type {number}
  * @memberof Article
  */
  total: number;
  /**
  * 
  * @type {boolean}
  * @memberof Article
  */
  selected: boolean;
  /**
  * 
  * @type {number}
  * @memberof Article
  */
  quantity: number;
  /**
  * 
  * @type {boolean}
  * @memberof Article
  */
  allowRemove?: boolean;
  /**
  * 
  * @type {string}
  * @memberof Article
  */
  relatedClassId?: string;
  /**
  * 
  * @type {string}
  * @memberof Article
  */
  relatedProductId?: string;
  /**
  * 
  * @type {Array<FieldHeading>}
  * @memberof Article
  */
  fieldHeadings?: Array<FieldHeading>;
}/**
* 
* @export
* @class Cart
*/
export class Cart {
  /**
  * 
  * @type {string}
  * @memberof Cart
  */
  data: string;
}/**
* 
* @export
* @class CheckoutModel
*/
export class CheckoutModel {
  /**
  * 
  * @type {CommonError}
  * @memberof CheckoutModel
  */
  error?: CommonError;
  /**
  * 
  * @type {ValidationError}
  * @memberof CheckoutModel
  */
  validationErrors?: ValidationError;
  /**
  * 
  * @type {Array<ContactNode>}
  * @memberof CheckoutModel
  */
  contactNodes?: Array<ContactNode>;
  /**
  * 
  * @type {Amount}
  * @memberof CheckoutModel
  */
  amount?: Amount;
  /**
  * 
  * @type {string}
  * @memberof CheckoutModel
  */
  payerId?: string;
}/**
* 
* @export
* @class CheckoutModelRequest
*/
export class CheckoutModelRequest {
  /**
  * 
  * @type {Array<ContactNode>}
  * @memberof CheckoutModelRequest
  */
  contactNodes?: Array<ContactNode>;
  /**
  * 
  * @type {Array<string>}
  * @memberof CheckoutModelRequest
  */
  promotionIds?: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof CheckoutModelRequest
  */
  redeemedVoucherIds?: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof CheckoutModelRequest
  */
  redeemedVoucherProductIds?: Array<string>;
  /**
  * 
  * @type {string}
  * @memberof CheckoutModelRequest
  */
  payerId?: string;
  /**
  * 
  * @type {boolean}
  * @memberof CheckoutModelRequest
  */
  applyCredit?: boolean;
  /**
  * actual amount allocated for invoice/invoices (equalse subTotal if payment plan invoices not presented)
  * @type {number}
  * @memberof CheckoutModelRequest
  */
  payNow?: number;
  /**
  * 
  * @type {string}
  * @memberof CheckoutModelRequest
  */
  corporatePassId?: string;
}

export const ClassType = createStringEnum([
  'With Sessions',
  'Distant Learning',
  'Hybrid',
]);

export type ClassType = keyof typeof ClassType;
/**
* 
* @export
* @class ClientPreferences
*/
export class ClientPreferences {
  /**
  * key for client operations with payment system
  * @type {string}
  * @memberof ClientPreferences
  */
  clientKey?: string;
  /**
  * location id of application for square payment system
  * @type {string}
  * @memberof ClientPreferences
  */
  locationId?: string;
}/**
* 
* @export
* @class CodeResponse
*/
export class CodeResponse {
  /**
  * 
  * @type {Promotion}
  * @memberof CodeResponse
  */
  promotion?: Promotion;
  /**
  * 
  * @type {RedeemVoucher}
  * @memberof CodeResponse
  */
  voucher?: RedeemVoucher;
}/**
* 
* @export
* @class CommonError
*/
export class CommonError {
  /**
  * 
  * @type {number}
  * @memberof CommonError
  */
  code?: number;
  /**
  * 
  * @type {string}
  * @memberof CommonError
  */
  message?: string;
}/**
* 
* @export
* @class Concession
*/
export class Concession {
  /**
  * 
  * @type {string}
  * @memberof Concession
  */
  concessionTypeId?: string;
  /**
  * 
  * @type {string}
  * @memberof Concession
  */
  contactId?: string;
  /**
  * 
  * @type {string}
  * @memberof Concession
  */
  name?: string;
  /**
  * 
  * @type {string}
  * @memberof Concession
  */
  expiryDate?: string;
  /**
  * 
  * @type {string}
  * @memberof Concession
  */
  number?: string;
}/**
* 
* @export
* @class ConcessionType
*/
export class ConcessionType {
  /**
  * 
  * @type {string}
  * @memberof ConcessionType
  */
  id?: string;
  /**
  * 
  * @type {string}
  * @memberof ConcessionType
  */
  name?: string;
  /**
  * 
  * @type {boolean}
  * @memberof ConcessionType
  */
  hasExpireDate?: boolean;
  /**
  * 
  * @type {boolean}
  * @memberof ConcessionType
  */
  hasNumber?: boolean;
}/**
* 
* @export
* @class ConcessionsAndMemberships
*/
export class ConcessionsAndMemberships {
  /**
  * 
  * @type {Array<Concession>}
  * @memberof ConcessionsAndMemberships
  */
  concessions?: Array<Concession>;
  /**
  * 
  * @type {Array<StudentMembership>}
  * @memberof ConcessionsAndMemberships
  */
  memberships?: Array<StudentMembership>;
}/**
* 
* @export
* @class Contact
*/
export class Contact {
  /**
  * Internal Unique identifier of course
  * @type {string}
  * @memberof Contact
  */
  id?: string;
  /**
  * Unique identifier of contact
  * @type {string}
  * @memberof Contact
  */
  uniqueIdentifier?: string;
  /**
  * first name of contact
  * @type {string}
  * @memberof Contact
  */
  firstName?: string;
  /**
  * last name of contact
  * @type {string}
  * @memberof Contact
  */
  lastName?: string;
  /**
  * email of contact
  * @type {string}
  * @memberof Contact
  */
  email?: string;
  /**
  * Is company flag
  * @type {boolean}
  * @memberof Contact
  */
  company?: boolean;
  /**
  * 
  * @type {boolean}
  * @memberof Contact
  */
  parentRequired?: boolean;
}/**
* 
* @export
* @class ContactFields
*/
export class ContactFields {
  /**
  * Contact Id
  * @type {string}
  * @memberof ContactFields
  */
  contactId: string;
  /**
  * Related field headings
  * @type {Array<FieldHeading>}
  * @memberof ContactFields
  */
  headings: Array<FieldHeading>;
}/**
* 
* @export
* @class ContactFieldsRequest
*/
export class ContactFieldsRequest {
  /**
  * Requested contact id
  * @type {string}
  * @memberof ContactFieldsRequest
  */
  contactId: string;
  /**
  * Requested classe's ids
  * @type {Array<string>}
  * @memberof ContactFieldsRequest
  */
  classIds: Array<string>;
  /**
  * Requested product's ids
  * @type {Array<ProductContainer>}
  * @memberof ContactFieldsRequest
  */
  products: Array<ProductContainer>;
  /**
  * Requested waiting list courses ids
  * @type {Array<string>}
  * @memberof ContactFieldsRequest
  */
  waitingCourseIds: Array<string>;
  /**
  * Flag to show only mandatory fields
  * @type {boolean}
  * @memberof ContactFieldsRequest
  */
  mandatoryOnly: boolean;
  /**
  * 
  * @type {FieldSet}
  * @memberof ContactFieldsRequest
  */
  fieldSet: FieldSet;
  /**
  * 
  * @type {boolean}
  * @memberof ContactFieldsRequest
  */
  isPayer: boolean;
  /**
  * 
  * @type {boolean}
  * @memberof ContactFieldsRequest
  */
  isParent: boolean;
}/**
* 
* @export
* @class ContactId
*/
export class ContactId {
  /**
  * Contact id
  * @type {string}
  * @memberof ContactId
  */
  id?: string;
  /**
  * Indicates that new contact created
  * @type {boolean}
  * @memberof ContactId
  */
  newContact?: boolean;
  /**
  * Indicates that parent required
  * @type {boolean}
  * @memberof ContactId
  */
  parentRequired?: boolean;
}/**
* 
* @export
* @class ContactNode
*/
export class ContactNode {
  /**
  * 
  * @type {string}
  * @memberof ContactNode
  */
  contactId: string;
  /**
  * 
  * @type {string}
  * @memberof ContactNode
  */
  contactFirstName: string;
  /**
  * 
  * @type {string}
  * @memberof ContactNode
  */
  contactLastName: string;
  /**
  * 
  * @type {string}
  * @memberof ContactNode
  */
  contactEmail: string;
  /**
  * 
  * @type {Array<Enrolment>}
  * @memberof ContactNode
  */
  enrolments: Array<Enrolment>;
  /**
  * 
  * @type {Array<Application>}
  * @memberof ContactNode
  */
  applications: Array<Application>;
  /**
  * 
  * @type {Array<Article>}
  * @memberof ContactNode
  */
  articles: Array<Article>;
  /**
  * 
  * @type {Array<Membership>}
  * @memberof ContactNode
  */
  memberships: Array<Membership>;
  /**
  * 
  * @type {Array<Voucher>}
  * @memberof ContactNode
  */
  vouchers: Array<Voucher>;
  /**
  * 
  * @type {Array<WaitingList>}
  * @memberof ContactNode
  */
  waitingLists: Array<WaitingList>;
  /**
  * 
  * @type {Array<string>}
  * @memberof ContactNode
  */
  suggestedCourseIds?: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof ContactNode
  */
  suggestedProductIds?: Array<string>;
}/**
* 
* @export
* @class ContactNodeRequest
*/
export class ContactNodeRequest {
  /**
  * 
  * @type {string}
  * @memberof ContactNodeRequest
  */
  contactId: string;
  /**
  * 
  * @type {Array<string>}
  * @memberof ContactNodeRequest
  */
  classIds: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof ContactNodeRequest
  */
  waitingCourseIds: Array<string>;
  /**
  * 
  * @type {Array<ProductContainer>}
  * @memberof ContactNodeRequest
  */
  products: Array<ProductContainer>;
  /**
  * 
  * @type {Array<string>}
  * @memberof ContactNodeRequest
  */
  promotionIds: Array<string>;
}/**
* 
* @export
* @class ContactParams
*/
export class ContactParams {
  /**
  * Internal Unique identifier of course
  * @type {string}
  * @memberof ContactParams
  */
  id?: string;
}/**
* 
* @export
* @class CorporatePass
*/
export class CorporatePass {
  /**
  * 
  * @type {string}
  * @memberof CorporatePass
  */
  id?: string;
  /**
  * 
  * @type {string}
  * @memberof CorporatePass
  */
  code?: string;
  /**
  * 
  * @type {string}
  * @memberof CorporatePass
  */
  message?: string;
  /**
  * 
  * @type {string}
  * @memberof CorporatePass
  */
  email?: string;
  /**
  * 
  * @type {string}
  * @memberof CorporatePass
  */
  name?: string;
}/**
* 
* @export
* @class Course
*/
export class Course {
  /**
  * Internal Unique identifier of course
  * @type {string}
  * @memberof Course
  */
  id?: string;
  /**
  * When course was created
  * @type {string}
  * @memberof Course
  */
  publishDate?: string;
  /**
  * When course was updated
  * @type {string}
  * @memberof Course
  */
  updateDate?: string;
  /**
  * Name of related faculty
  * @type {string}
  * @memberof Course
  */
  courseFaculty?: string;
  /**
  * value of extended course type
  * @type {string}
  * @memberof Course
  */
  courseType?: string;
  /**
  * Code of course
  * @type {string}
  * @memberof Course
  */
  code?: string;
  /**
  * Name of course
  * @type {string}
  * @memberof Course
  */
  name?: string;
  /**
  * Description of course
  * @type {string}
  * @memberof Course
  */
  description?: string;
  /**
  * Has enrollable classes
  * @type {boolean}
  * @memberof Course
  */
  hasCurrentClasses?: boolean;
  /**
  * Has more available places
  * @type {boolean}
  * @memberof Course
  */
  hasMoreAvailablePlaces?: boolean;
  /**
  * Value of course level tag
  * @type {string}
  * @memberof Course
  */
  courseLevel?: string;
  /**
  * 
  * @type {string}
  * @memberof Course
  */
  courseDuration?: string;
  /**
  * 
  * @type {string}
  * @memberof Course
  */
  nextClassDeliveryMode?: string;
  /**
  * 
  * @type {number}
  * @memberof Course
  */
  courseAttainment?: number;
  /**
  * 
  * @type {string}
  * @memberof Course
  */
  classesLowestPrice?: string;
  /**
  * 
  * @type {string}
  * @memberof Course
  */
  classesHighestPrice?: string;
}/**
* 
* @export
* @class CourseClass
*/
export class CourseClass {
  /**
  * Internal Unique identifier of class
  * @type {string}
  * @memberof CourseClass
  */
  id?: string;
  /**
  * 
  * @type {Course}
  * @memberof CourseClass
  */
  course?: Course;
  /**
  * Code of class
  * @type {string}
  * @memberof CourseClass
  */
  code?: string;
  /**
  * Class start date and time in UTC time zone (+00:00),date format is ISO 8601
  * @type {string}
  * @memberof CourseClass
  */
  start?: string;
  /**
  * Class start date and time in UTC time zone (+00:00),date format is ISO 8601
  * @type {string}
  * @memberof CourseClass
  */
  end?: string;
  /**
  * Available places
  * @type {boolean}
  * @memberof CourseClass
  */
  hasAvailablePlaces?: boolean;
  /**
  * Number of free places
  * @type {number}
  * @memberof CourseClass
  */
  availableEnrolmentPlaces?: number;
  /**
  * Is class finished
  * @type {boolean}
  * @memberof CourseClass
  */
  isFinished?: boolean;
  /**
  * Is class cancelled
  * @type {boolean}
  * @memberof CourseClass
  */
  isCancelled?: boolean;
  /**
  * Allow by application
  * @type {boolean}
  * @memberof CourseClass
  */
  isAllowByApplication?: boolean;
  /**
  * Is payment gateway enabled
  * @type {boolean}
  * @memberof CourseClass
  */
  isPaymentGatewayEnabled?: boolean;
  /**
  * 
  * @type {ClassType}
  * @memberof CourseClass
  */
  type?: ClassType;
  /**
  * 
  * @type {CourseClassPrice}
  * @memberof CourseClass
  */
  price?: CourseClassPrice;
  /**
  * 
  * @type {Room}
  * @memberof CourseClass
  */
  room?: Room;
  /**
  * Timezone for the class
  * @type {string}
  * @memberof CourseClass
  */
  timezone?: string;
  /**
  * Course Subject tag name
  * @type {string}
  * @memberof CourseClass
  */
  subject?: string;
  /**
  * Class delivery mode
  * @type {string}
  * @memberof CourseClass
  */
  deliveryMode?: string;
}/**
* 
* @export
* @class CourseClassPrice
*/
export class CourseClassPrice {
  /**
  * Full class price
  * @type {number}
  * @memberof CourseClassPrice
  */
  fee?: number;
  /**
  * Class price overriden by application
  * @type {number}
  * @memberof CourseClassPrice
  */
  feeOverriden?: number;
  /**
  * Class tax overriden by application
  * @type {number}
  * @memberof CourseClassPrice
  */
  feeOverridenTax?: number;
  /**
  * 
  * @type {Discount}
  * @memberof CourseClassPrice
  */
  appliedDiscount?: Discount;
  /**
  * List discounts sorted by discounted fee
  * @type {Array<Discount>}
  * @memberof CourseClassPrice
  */
  possibleDiscounts?: Array<Discount>;
  /**
  * 
  * @type {boolean}
  * @memberof CourseClassPrice
  */
  hasTax?: boolean;
}/**
* 
* @export
* @class CourseClassesParams
*/
export class CourseClassesParams {
  /**
  * List of requested course classes by id
  * @type {Array<string>}
  * @memberof CourseClassesParams
  */
  courseClassesIds?: Array<string>;
  /**
  * List of requested course classes by code
  * @type {Array<string>}
  * @memberof CourseClassesParams
  */
  courseClassesCodes?: Array<string>;
  /**
  * List of applied promotions
  * @type {Array<PromotionParams>}
  * @memberof CourseClassesParams
  */
  promotions?: Array<PromotionParams>;
  /**
  * 
  * @type {ContactParams}
  * @memberof CourseClassesParams
  */
  contact?: ContactParams;
}/**
* 
* @export
* @class CoursesParams
*/
export class CoursesParams {
  /**
  * List of requested courses by id
  * @type {Array<string>}
  * @memberof CoursesParams
  */
  coursesIds?: Array<string>;
  /**
  * List of requested courses by code
  * @type {Array<string>}
  * @memberof CoursesParams
  */
  coursesCodes?: Array<string>;
}/**
* 
* @export
* @class CreateContactParams
*/
export class CreateContactParams {
  /**
  * First Name of Contact
  * @type {string}
  * @memberof CreateContactParams
  */
  firstName: string;
  /**
  * Last Name of Contact
  * @type {string}
  * @memberof CreateContactParams
  */
  lastName: string;
  /**
  * Email of Contact
  * @type {string}
  * @memberof CreateContactParams
  */
  email: string;
  /**
  * 
  * @type {FieldSet}
  * @memberof CreateContactParams
  */
  fieldSet: FieldSet;
  /**
  * Is company flag
  * @type {boolean}
  * @memberof CreateContactParams
  */
  company?: boolean;
}/**
* 
* @export
* @class CreateParentChildrenRequest
*/
export class CreateParentChildrenRequest {
  /**
  * 
  * @type {string}
  * @memberof CreateParentChildrenRequest
  */
  parentId?: string;
  /**
  * 
  * @type {Array<string>}
  * @memberof CreateParentChildrenRequest
  */
  childrenIds?: Array<string>;
}/**
* 
* @export
* @class Currency
*/
export class Currency {
  /**
  * Full name of currency
  * @type {string}
  * @memberof Currency
  */
  name?: string;
  /**
  * Short currency symbol representation displayed to the user
  * @type {string}
  * @memberof Currency
  */
  shortCurrencySymbol?: string;
  /**
  * Currency code according to ISO 3166-1 A-3
  * @type {string}
  * @memberof Currency
  */
  currencySymbol?: string;
}

export const DataType = createStringEnum([
  'STRING',
  'LONG_STRING',
  'PATTERN_TEXT',
  'BOOLEAN',
  'DATE',
  'DATETIME',
  'INTEGER',
  'COUNTRY',
  'LANGUAGE',
  'ENUM',
  'EMAIL',
  'SUBURB',
  'POSTCODE',
  'PHONE',
  'CHOICE',
  'TAGGROUP_S',
  'TAGGROUP_M',
  'MAILINGLIST',
  'MONEY',
  'URL',
  'FILE',
]);

export type DataType = keyof typeof DataType;
/**
* 
* @export
* @class Discount
*/
export class Discount {
  /**
  * Internal Unique identifier of discount
  * @type {string}
  * @memberof Discount
  */
  id?: string;
  /**
  * 
  * @type {string}
  * @memberof Discount
  */
  expiryDate?: string;
  /**
  * 
  * @type {number}
  * @memberof Discount
  */
  discountedFee?: number;
  /**
  * 
  * @type {number}
  * @memberof Discount
  */
  discountValue?: number;
  /**
  * 
  * @type {string}
  * @memberof Discount
  */
  title?: string;
}/**
* 
* @export
* @class Document
*/
export class Document {
  /**
  * 
  * @type {string}
  * @memberof Document
  */
  name?: string;
  /**
  * 
  * @type {string}
  * @memberof Document
  */
  content?: string;
}/**
* 
* @export
* @class Enrolment
*/
export class Enrolment {
  /**
  * 
  * @type {string}
  * @memberof Enrolment
  */
  contactId: string;
  /**
  * 
  * @type {string}
  * @memberof Enrolment
  */
  classId: string;
  /**
  * 
  * @type {string}
  * @memberof Enrolment
  */
  courseId?: string;
  /**
  * 
  * @type {CourseClassPrice}
  * @memberof Enrolment
  */
  price: CourseClassPrice;
  /**
  * 
  * @type {Array<string>}
  * @memberof Enrolment
  */
  warnings: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof Enrolment
  */
  errors: Array<string>;
  /**
  * 
  * @type {boolean}
  * @memberof Enrolment
  */
  selected: boolean;
  /**
  * 
  * @type {Array<FieldHeading>}
  * @memberof Enrolment
  */
  fieldHeadings: Array<FieldHeading>;
  /**
  * 
  * @type {boolean}
  * @memberof Enrolment
  */
  allowRemove?: boolean;
  /**
  * 
  * @type {string}
  * @memberof Enrolment
  */
  relatedClassId?: string;
  /**
  * 
  * @type {string}
  * @memberof Enrolment
  */
  relatedProductId?: string;
}/**
* 
* @export
* @class Field
*/
export class Field {
  /**
  * Field id
  * @type {string}
  * @memberof Field
  */
  id: string;
  /**
  * Property key
  * @type {string}
  * @memberof Field
  */
  key: string;
  /**
  * Field name
  * @type {string}
  * @memberof Field
  */
  name: string;
  /**
  * Field pattern ( PATTERN_TEXT only )
  * @type {string}
  * @memberof Field
  */
  pattern?: string;
  /**
  * Field description
  * @type {string}
  * @memberof Field
  */
  description: string;
  /**
  * Mandatory flag
  * @type {boolean}
  * @memberof Field
  */
  mandatory: boolean;
  /**
  * 
  * @type {DataType}
  * @memberof Field
  */
  dataType: DataType;
  /**
  * Enumeration name which is type for field value
  * @type {string}
  * @memberof Field
  */
  enumType: string;
  /**
  * Value for corresponded property
  * @type {string}
  * @memberof Field
  */
  value: string;
  /**
  * 
  * @type {Item}
  * @memberof Field
  */
  itemValue?: Item;
  /**
  * Default value for corresponded property
  * @type {string}
  * @memberof Field
  */
  defaultValue: string;
  /**
  * Combobox choices for enumeration types
  * @type {Array<Item>}
  * @memberof Field
  */
  enumItems: Array<Item>;
  /**
  * order position
  * @type {number}
  * @memberof Field
  */
  ordering: number;
  /**
  * Key of field that must have specific value to allow this field to be shown
  * @type {string}
  * @memberof Field
  */
  relatedFieldKey?: string;
  /**
  * Value of related field that must be set to allow this field to be shown
  * @type {string}
  * @memberof Field
  */
  relatedFieldExpectedValue?: string;
  /**
  * Value of related field that was set (for contact details only)
  * @type {string}
  * @memberof Field
  */
  relatedFieldValue?: string;
  /**
  * 
  * @type {Document}
  * @memberof Field
  */
  fileValue?: Document;
  /**
  * Values allowed by validation type of field
  * @type {Array<string>}
  * @memberof Field
  */
  possibleValues?: Array<string>;
}/**
* 
* @export
* @class FieldError
*/
export class FieldError {
  /**
  * order position
  * @type {number}
  * @memberof FieldError
  */
  index: number;
  /**
  * Name of fiels with error
  * @type {string}
  * @memberof FieldError
  */
  name: string;
  /**
  * Errors for particular field, or empty array
  * @type {string}
  * @memberof FieldError
  */
  error: string;
}/**
* 
* @export
* @class FieldHeading
*/
export class FieldHeading {
  /**
  * Heading name
  * @type {string}
  * @memberof FieldHeading
  */
  name: string;
  /**
  * Heading description
  * @type {string}
  * @memberof FieldHeading
  */
  description: string;
  /**
  * Fields set related to field heading
  * @type {Array<Field>}
  * @memberof FieldHeading
  */
  fields: Array<Field>;
  /**
  * order position
  * @type {number}
  * @memberof FieldHeading
  */
  ordering: number;
}

export const FieldSet = createStringEnum([
  'ENROLMENT',
  'WAITINGLIST',
]);

export type FieldSet = keyof typeof FieldSet;
/**
* 
* @export
* @class GetCorporatePassRequest
*/
export class GetCorporatePassRequest {
  /**
  * 
  * @type {string}
  * @memberof GetCorporatePassRequest
  */
  code?: string;
  /**
  * 
  * @type {Array<string>}
  * @memberof GetCorporatePassRequest
  */
  classIds?: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof GetCorporatePassRequest
  */
  productIds?: Array<string>;
}/**
* 
* @export
* @class Item
*/
export class Item {
  /**
  * Key which will be send back
  * @type {string}
  * @memberof Item
  */
  key?: string;
  /**
  * Value which user will see
  * @type {any}
  * @memberof Item
  */
  value?: any;
}/**
* 
* @export
* @class Location
*/
export class Location {
  /**
  * 
  * @type {number}
  * @memberof Location
  */
  id?: number;
  /**
  * Proper name of the country
  * @type {string}
  * @memberof Location
  */
  name?: string;
  /**
  * 
  * @type {Currency}
  * @memberof Location
  */
  currency?: Currency;
  /**
  * Country code according to ISO 3166-1 A-2
  * @type {string}
  * @memberof Location
  */
  countryCode?: string;
  /**
  * 
  * @type {string}
  * @memberof Location
  */
  languageCode?: string;
}/**
* 
* @export
* @class MakeCorporatePassRequest
*/
export class MakeCorporatePassRequest {
  /**
  * 
  * @type {CheckoutModelRequest}
  * @memberof MakeCorporatePassRequest
  */
  checkoutModelRequest?: CheckoutModelRequest;
  /**
  * 
  * @type {boolean}
  * @memberof MakeCorporatePassRequest
  */
  agreementFlag?: boolean;
  /**
  * 
  * @type {string}
  * @memberof MakeCorporatePassRequest
  */
  corporatePassId?: string;
  /**
  * 
  * @type {string}
  * @memberof MakeCorporatePassRequest
  */
  reference?: string;
}/**
* 
* @export
* @class Membership
*/
export class Membership {
  /**
  * 
  * @type {string}
  * @memberof Membership
  */
  contactId: string;
  /**
  * 
  * @type {string}
  * @memberof Membership
  */
  productId: string;
  /**
  * 
  * @type {Array<string>}
  * @memberof Membership
  */
  warnings: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof Membership
  */
  errors: Array<string>;
  /**
  * 
  * @type {number}
  * @memberof Membership
  */
  price: number;
  /**
  * 
  * @type {boolean}
  * @memberof Membership
  */
  selected: boolean;
  /**
  * 
  * @type {boolean}
  * @memberof Membership
  */
  allowRemove?: boolean;
  /**
  * 
  * @type {string}
  * @memberof Membership
  */
  relatedClassId?: string;
  /**
  * 
  * @type {string}
  * @memberof Membership
  */
  relatedProductId?: string;
  /**
  * 
  * @type {Array<FieldHeading>}
  * @memberof Membership
  */
  fieldHeadings?: Array<FieldHeading>;
}

export const PaymentStatus = createStringEnum([
  'IN_PROGRESS',
  'FAILED',
  'SUCCESSFUL',
  'UNDEFINED',
  'SUCCESSFUL_WAITING_COURSES',
  'SUCCESSFUL_BY_PASS',
]);

export type PaymentStatus = keyof typeof PaymentStatus;
/**
* 
* @export
* @class Preferences
*/
export class Preferences {
  /**
  * is corporate pass enabled preference
  * @type {boolean}
  * @memberof Preferences
  */
  corporatePassEnabled?: boolean;
  /**
  * is credit card enabled preference
  * @type {boolean}
  * @memberof Preferences
  */
  creditCardEnabled?: boolean;
  /**
  * Minimal age which not requiring parent
  * @type {number}
  * @memberof Preferences
  */
  minAge?: number;
  /**
  * Terms and conditions display label
  * @type {string}
  * @memberof Preferences
  */
  termsLabel?: string;
  /**
  * Terms and conditions page url
  * @type {string}
  * @memberof Preferences
  */
  termsUrl?: string;
  /**
  * Payment gatewat type for college selected in Admin
  * @type {string}
  * @memberof Preferences
  */
  paymentGatewayType?: string;
  /**
  * 
  * @type {boolean}
  * @memberof Preferences
  */
  contactDetailsEditable?: boolean;
  /**
  * 
  * @type {boolean}
  * @memberof Preferences
  */
  adobeAnalyticsEnablde?: boolean;
  /**
  * 
  * @type {Location}
  * @memberof Preferences
  */
  location?: Location;
}/**
* 
* @export
* @class Product
*/
export class Product {
  /**
  * Internal Unique identifier of product
  * @type {string}
  * @memberof Product
  */
  id?: string;
  /**
  * Code of product
  * @type {string}
  * @memberof Product
  */
  code?: string;
  /**
  * Name of product
  * @type {string}
  * @memberof Product
  */
  name?: string;
  /**
  * Description of product
  * @type {string}
  * @memberof Product
  */
  description?: string;
  /**
  * Is payment gateway enabled
  * @type {boolean}
  * @memberof Product
  */
  isPaymentGatewayEnabled?: boolean;
  /**
  * Is on sale and is Web visible
  * @type {boolean}
  * @memberof Product
  */
  canBuy?: boolean;
  /**
  * 
  * @type {ProductType}
  * @memberof Product
  */
  type?: ProductType;
  /**
  * 
  * @type {boolean}
  * @memberof Product
  */
  allowRemove?: boolean;
  /**
  * 
  * @type {string}
  * @memberof Product
  */
  relatedClassId?: string;
  /**
  * Product price
  * @type {number}
  * @memberof Product
  */
  price?: number;
}/**
* 
* @export
* @class ProductContainer
*/
export class ProductContainer {
  /**
  * 
  * @type {string}
  * @memberof ProductContainer
  */
  productId: string;
  /**
  * 
  * @type {number}
  * @memberof ProductContainer
  */
  quantity: number;
}

export const ProductType = createStringEnum([
  'ARTICLE',
  'MEMBERSHIP',
  'VOUCHER',
]);

export type ProductType = keyof typeof ProductType;
/**
* 
* @export
* @class ProductsParams
*/
export class ProductsParams {
  /**
  * List of requested  products by id
  * @type {Array<string>}
  * @memberof ProductsParams
  */
  productsIds?: Array<string>;
  /**
  * List of requested  products by code
  * @type {Array<string>}
  * @memberof ProductsParams
  */
  productsCodes?: Array<string>;
  /**
  * List of applied promotions
  * @type {Array<PromotionParams>}
  * @memberof ProductsParams
  */
  promotions?: Array<PromotionParams>;
  /**
  * 
  * @type {ContactParams}
  * @memberof ProductsParams
  */
  contact?: ContactParams;
}/**
* 
* @export
* @class Promotion
*/
export class Promotion {
  /**
  * Internal unique indetificator of promotion
  * @type {string}
  * @memberof Promotion
  */
  id?: string;
  /**
  * Code of promotion
  * @type {string}
  * @memberof Promotion
  */
  code?: string;
  /**
  * Name of promotion
  * @type {string}
  * @memberof Promotion
  */
  name?: string;
}/**
* 
* @export
* @class PromotionParams
*/
export class PromotionParams {
  /**
  * Internal unique indetificator of promotion
  * @type {string}
  * @memberof PromotionParams
  */
  id?: string;
}/**
* 
* @export
* @class RedeemVoucher
*/
export class RedeemVoucher {
  /**
  * 
  * @type {string}
  * @memberof RedeemVoucher
  */
  id?: string;
  /**
  * 
  * @type {Contact}
  * @memberof RedeemVoucher
  */
  payer?: Contact;
  /**
  * 
  * @type {string}
  * @memberof RedeemVoucher
  */
  name?: string;
  /**
  * 
  * @type {string}
  * @memberof RedeemVoucher
  */
  code?: string;
}/**
* 
* @export
* @class Room
*/
export class Room {
  /**
  * Room name
  * @type {string}
  * @memberof Room
  */
  name?: string;
  /**
  * 
  * @type {Site}
  * @memberof Room
  */
  site?: Site;
}/**
* 
* @export
* @class Site
*/
export class Site {
  /**
  * Site name
  * @type {string}
  * @memberof Site
  */
  name?: string;
  /**
  * Site address
  * @type {string}
  * @memberof Site
  */
  street?: string;
  /**
  * Site suburb
  * @type {string}
  * @memberof Site
  */
  suburb?: string;
  /**
  * Site postcode
  * @type {string}
  * @memberof Site
  */
  postcode?: string;
}/**
* 
* @export
* @class StudentMembership
*/
export class StudentMembership {
  /**
  * 
  * @type {string}
  * @memberof StudentMembership
  */
  contactId?: string;
  /**
  * 
  * @type {string}
  * @memberof StudentMembership
  */
  name?: string;
}/**
* 
* @export
* @class Suburb
*/
export class Suburb {
  /**
  * State that corresponds certain location
  * @type {string}
  * @memberof Suburb
  */
  state?: string;
  /**
  * Suburb that corresponds certain location
  * @type {string}
  * @memberof Suburb
  */
  suburb?: string;
  /**
  * Postcode that corresponds certain location
  * @type {string}
  * @memberof Suburb
  */
  postcode?: string;
}/**
* 
* @export
* @class V2CreateSessionResponse
*/
export class V2CreateSessionResponse {
  /**
  * Windcave session id
  * @type {string}
  * @memberof V2CreateSessionResponse
  */
  sessionId?: string;
  /**
  * Windcave iframe url
  * @type {string}
  * @memberof V2CreateSessionResponse
  */
  ccFormUrl?: string;
  /**
  * server side generated UUID
  * @type {string}
  * @memberof V2CreateSessionResponse
  */
  merchantReference?: string;
  /**
  * client secret for embedded form operation
  * @type {string}
  * @memberof V2CreateSessionResponse
  */
  clientSecret?: string;
}/**
* 
* @export
* @class V2PaymentPrepareRequest
*/
export class V2PaymentPrepareRequest {
  /**
  * 
  * @type {CheckoutModelRequest}
  * @memberof V2PaymentPrepareRequest
  */
  checkoutModelRequest?: CheckoutModelRequest;
  /**
  * Amount allocated for credit card payment
  * @type {number}
  * @memberof V2PaymentPrepareRequest
  */
  ccAmount?: number;
  /**
  * save CC details to proc
  * @type {boolean}
  * @memberof V2PaymentPrepareRequest
  */
  storeCard?: boolean;
  /**
  * List of previous invoice ids to pay them, if they were seleted
  * @type {Array<number>}
  * @memberof V2PaymentPrepareRequest
  */
  previousInvoiceIds?: Array<number>;
}/**
* 
* @export
* @class V2PaymentRequest
*/
export class V2PaymentRequest {
  /**
  * 
  * @type {string}
  * @memberof V2PaymentRequest
  */
  merchantReference?: string;
  /**
  * String length 16 of hexadecimal digits
  * @type {string}
  * @memberof V2PaymentRequest
  */
  onCourseSessionId?: string;
  /**
  * String length 16 of hexadecimal digits
  * @type {string}
  * @memberof V2PaymentRequest
  */
  transactionId?: string;
  /**
  * token of card data, collected with client
  * @type {string}
  * @memberof V2PaymentRequest
  */
  cardDataToken?: string;
  /**
  * method id of stripe payment system
  * @type {string}
  * @memberof V2PaymentRequest
  */
  paymentSystemMethodId?: string;
  /**
  * 3d secure code
  * @type {string}
  * @memberof V2PaymentRequest
  */
  secureCode?: string;
}/**
* 
* @export
* @class V2PaymentResponse
*/
export class V2PaymentResponse {
  /**
  * 
  * @type {string}
  * @memberof V2PaymentResponse
  */
  sessionId?: string;
  /**
  * 
  * @type {string}
  * @memberof V2PaymentResponse
  */
  merchantReference?: string;
  /**
  * 
  * @type {PaymentStatus}
  * @memberof V2PaymentResponse
  */
  status?: PaymentStatus;
  /**
  * 
  * @type {string}
  * @memberof V2PaymentResponse
  */
  reference?: string;
  /**
  * 
  * @type {string}
  * @memberof V2PaymentResponse
  */
  responseText?: string;
  /**
  * 
  * @type {string}
  * @memberof V2PaymentResponse
  */
  paymentFormUrl?: string;
  /**
  * 
  * @type {string}
  * @memberof V2PaymentResponse
  */
  clientSecret?: string;
  /**
  * 
  * @type {boolean}
  * @memberof V2PaymentResponse
  */
  actionRequired?: boolean;
}/**
* 
* @export
* @class V2SuggestionRequest
*/
export class V2SuggestionRequest {
  /**
  * 
  * @type {Array<string>}
  * @memberof V2SuggestionRequest
  */
  courseIds?: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof V2SuggestionRequest
  */
  productIds?: Array<string>;
}/**
* 
* @export
* @class V2SuggestionResponse
*/
export class V2SuggestionResponse {
  /**
  * 
  * @type {Array<string>}
  * @memberof V2SuggestionResponse
  */
  courseClasses?: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof V2SuggestionResponse
  */
  products?: Array<string>;
}/**
* 
* @export
* @class ValidationError
*/
export class ValidationError {
  /**
  * Global error
  * @type {Array<string>}
  * @memberof ValidationError
  */
  formErrors: Array<string>;
  /**
  * 
  * @type {Array<FieldError>}
  * @memberof ValidationError
  */
  fieldsErrors: Array<FieldError>;
}/**
* 
* @export
* @class Voucher
*/
export class Voucher {
  /**
  * 
  * @type {string}
  * @memberof Voucher
  */
  contactId: string;
  /**
  * 
  * @type {string}
  * @memberof Voucher
  */
  productId: string;
  /**
  * 
  * @type {Array<string>}
  * @memberof Voucher
  */
  warnings: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof Voucher
  */
  errors: Array<string>;
  /**
  * 
  * @type {number}
  * @memberof Voucher
  */
  price: number;
  /**
  * 
  * @type {number}
  * @memberof Voucher
  */
  total: number;
  /**
  * 
  * @type {number}
  * @memberof Voucher
  */
  value?: number;
  /**
  * 
  * @type {Array<string>}
  * @memberof Voucher
  */
  classes?: Array<string>;
  /**
  * 
  * @type {boolean}
  * @memberof Voucher
  */
  selected: boolean;
  /**
  * 
  * @type {boolean}
  * @memberof Voucher
  */
  isEditablePrice: boolean;
  /**
  * 
  * @type {number}
  * @memberof Voucher
  */
  quantity: number;
  /**
  * 
  * @type {boolean}
  * @memberof Voucher
  */
  allowRemove?: boolean;
  /**
  * 
  * @type {string}
  * @memberof Voucher
  */
  relatedClassId?: string;
  /**
  * 
  * @type {string}
  * @memberof Voucher
  */
  relatedProductId?: string;
  /**
  * 
  * @type {Array<FieldHeading>}
  * @memberof Voucher
  */
  fieldHeadings?: Array<FieldHeading>;
}/**
* 
* @export
* @class VoucherPayment
*/
export class VoucherPayment {
  /**
  * 
  * @type {string}
  * @memberof VoucherPayment
  */
  redeemVoucherProductId?: string;
  /**
  * 
  * @type {string}
  * @memberof VoucherPayment
  */
  redeemVoucherId?: string;
  /**
  * 
  * @type {string}
  * @memberof VoucherPayment
  */
  name?: string;
  /**
  * 
  * @type {number}
  * @memberof VoucherPayment
  */
  amount?: number;
}/**
* 
* @export
* @class WaitingList
*/
export class WaitingList {
  /**
  * 
  * @type {number}
  * @memberof WaitingList
  */
  studentsCount: number;
  /**
  * 
  * @type {string}
  * @memberof WaitingList
  */
  detail: string;
  /**
  * 
  * @type {string}
  * @memberof WaitingList
  */
  contactId: string;
  /**
  * 
  * @type {string}
  * @memberof WaitingList
  */
  courseId: string;
  /**
  * 
  * @type {Array<string>}
  * @memberof WaitingList
  */
  warnings: Array<string>;
  /**
  * 
  * @type {Array<string>}
  * @memberof WaitingList
  */
  errors: Array<string>;
  /**
  * 
  * @type {boolean}
  * @memberof WaitingList
  */
  selected: boolean;
  /**
  * 
  * @type {Array<FieldHeading>}
  * @memberof WaitingList
  */
  fieldHeadings: Array<FieldHeading>;
}
export class CartApi {

    constructor(private http: any) {}

    create(body: Cart, id: number): Promise<any> {
      return this.http.POST(`/v1/cart/${id}`, body, { headers: {}, params: {}, responseType: '' });
    }

    get(id: number): Promise<string> {
      return this.http.GET(`/v1/cart/${id}`, { headers: {}, params: {}, responseType: '' });
    }

    remove(id: number): Promise<any> {
      return this.http.DELETE(`/v1/cart/${id}`, { headers: {}, params: {}, responseType: '' });
    }
}

export class CheckoutV2Api {

    constructor(private http: any) {}

    createSession(body: V2PaymentPrepareRequest, payerId: string, xOrigin: string, deprecatedSessionId: string): Promise<V2CreateSessionResponse> {
      return this.http.POST('/v2/createSession', body, { headers: { payerId, xOrigin }, params: { deprecatedSessionId }, responseType: '' });
    }

    getCheckoutModel(body: CheckoutModelRequest): Promise<CheckoutModel> {
      return this.http.POST('/v2/getCheckoutModel', body, { headers: {}, params: {}, responseType: '' });
    }

    getClientPreferences(): Promise<ClientPreferences> {
      return this.http.GET('/v2/clientPreferences', { headers: {}, params: {}, responseType: '' });
    }

    getContactNodeV2(body: ContactNodeRequest): Promise<ContactNode> {
      return this.http.POST('/v2/getContactNode', body, { headers: {}, params: {}, responseType: '' });
    }

    getStatus(sessionId: string): Promise<V2PaymentResponse> {
      return this.http.GET(`/v2/getPaymentStatus/${sessionId}`, { headers: {}, params: {}, responseType: '' });
    }

    submitCreditCardPayment(body: V2PaymentRequest, xOrigin: string, payerId: string): Promise<V2PaymentResponse> {
      return this.http.POST('/v2/submitCCPayment', body, { headers: { xOrigin, payerId }, params: {}, responseType: '' });
    }

    submitPayment(body: V2PaymentPrepareRequest, payerId: string): Promise<V2PaymentResponse> {
      return this.http.POST('/v2/submitPayment', body, { headers: { payerId }, params: {}, responseType: '' });
    }

    submitPaymentRedirect(paymentSessionId: string, webSiteKey: string): Promise<string> {
      return this.http.GET('/v2/submitPaymentRedirect', { headers: {}, params: { paymentSessionId, webSiteKey }, responseType: '' });
    }
}

export class ContactApi {

    constructor(private http: any) {}

    createOrGetContact(body: CreateContactParams): Promise<ContactId> {
      return this.http.PUT('/v1/contact/${studentUniqueIdentifier}', body, { headers: {}, params: {}, responseType: '' });
    }

    createParentChildrenRelation(body: CreateParentChildrenRequest): Promise<any> {
      return this.http.PUT('/v1/createParentChildrenRelation', body, { headers: {}, params: {}, responseType: '' });
    }

    getConcessionTypes(): Promise<Array<ConcessionType>> {
      return this.http.GET('/v1/getConcessionTypes', { headers: {}, params: {}, responseType: '' });
    }

    getContact(studentUniqueIdentifier: string): Promise<Contact> {
      return this.http.GET(`/v1/contact/${studentUniqueIdentifier}`, { headers: {}, params: {}, responseType: '' });
    }

    getContactConcessionsAndMemberships(body: Array<string>): Promise<ConcessionsAndMemberships> {
      return this.http.POST('/v1/getContactConcessionsAndMemberships', body, { headers: {}, params: {}, responseType: '' });
    }

    getContactFields(body: ContactFieldsRequest): Promise<ContactFields> {
      return this.http.POST('/v1/contactFields', body, { headers: {}, params: {}, responseType: '' });
    }

    submitConcession(body: Concession): Promise<any> {
      return this.http.PUT('/v1/submitConcession', body, { headers: {}, params: {}, responseType: '' });
    }

    submitContactDetails(body: ContactFields): Promise<ContactId> {
      return this.http.POST('/v1/submitContactDetails', body, { headers: {}, params: {}, responseType: '' });
    }
}

export class CorporatePassApi {

    constructor(private http: any) {}

    getCorporatePass(body: GetCorporatePassRequest): Promise<CorporatePass> {
      return this.http.POST('/v1/getCorporatePass', body, { headers: {}, params: {}, responseType: '' });
    }

    isCorporatePassEnabled(): Promise<boolean> {
      return this.http.GET('/v1/isCorporatePassEnabled', { headers: {}, params: {}, responseType: '' });
    }

    isCorporatePassEnabledFor(body: CheckoutModelRequest): Promise<boolean> {
      return this.http.POST('/v1/isCorporatePassEnabledFor', body, { headers: {}, params: {}, responseType: '' });
    }

    makeCorporatePass(body: MakeCorporatePassRequest): Promise<any> {
      return this.http.POST('/v1/makeCorporatePass', body, { headers: {}, params: {}, responseType: '' });
    }
}

export class CourseClassesApi {

    constructor(private http: any) {}

    getAvailableClasses(courseId: string): Promise<Array<CourseClass>> {
      return this.http.POST(`/v1/course/classes/$${courseId}`, {}, { headers: {}, params: {}, responseType: '' });
    }

    getCourseClasses(body: CourseClassesParams): Promise<Array<CourseClass>> {
      return this.http.POST('/v1/classes', body, { headers: {}, params: {}, responseType: '' });
    }

    getCourses(body: CoursesParams): Promise<Array<Course>> {
      return this.http.POST('/v1/courses', body, { headers: {}, params: {}, responseType: '' });
    }
}

export class PreferenceApi {

    constructor(private http: any) {}

    getPreferences(): Promise<Preferences> {
      return this.http.GET('/v1/getPreferences', { headers: {}, params: {}, responseType: '' });
    }
}

export class ProductsApi {

    constructor(private http: any) {}

    getProducts(body: ProductsParams): Promise<Array<Product>> {
      return this.http.POST('/v1/products', body, { headers: {}, params: {}, responseType: '' });
    }
}

export class PromotionApi {

    constructor(private http: any) {}

    getPromotion(code: string): Promise<Promotion> {
      return this.http.GET(`/v1/promotion/${code}`, { headers: {}, params: {}, responseType: '' });
    }

    submitCode(code: string): Promise<CodeResponse> {
      return this.http.GET(`/v1/submitCode/${code}`, { headers: {}, params: {}, responseType: '' });
    }
}

export class SearchApi {

    constructor(private http: any) {}

    getCountries(text: string): Promise<Array<Item>> {
      return this.http.GET(`/v1/country/${text}`, { headers: {}, params: {}, responseType: '' });
    }

    getLanguages(text: string): Promise<Array<Item>> {
      return this.http.GET(`/v1/language/${text}`, { headers: {}, params: {}, responseType: '' });
    }

    getPostcodes(text: string): Promise<Array<Item>> {
      return this.http.GET(`/v1/postcode/${text}`, { headers: {}, params: {}, responseType: '' });
    }

    getSuburbs(text: string): Promise<Array<Item>> {
      return this.http.GET(`/v1/suburb/${text}`, { headers: {}, params: {}, responseType: '' });
    }
}

export class SuggestionApi {

    constructor(private http: any) {}

    getSuggestion(body: V2SuggestionRequest): Promise<V2SuggestionResponse> {
      return this.http.POST('/v1/suggestion', body, { headers: {}, params: {}, responseType: '' });
    }
}


